import { Component, Vue } from 'nuxt-property-decorator'

import CODE_KEY from '@/config/code_key'

@Component
export class CodeKey extends Vue {
  readonly CODE_KEY = CODE_KEY
}
